import React from 'react'
import { Image, ImageProps } from '@chakra-ui/core'
import LogoImage from 'assets/logo.svg'

const Logo = (props: ImageProps) => {
  return <Image {...props} src={props.src || LogoImage} />
}

export default Logo
